export default function Steps() {
 const steps = [
  {
    number: "1",
    title: "Crea una cuenta",
    desc: "Crea una cuenta para tu restaurante o bar en minutos. Así de sencillo.",
    color: "from-blue-500 to-cyan-400",
    icon: "📝", // formulario / crear cuenta
  },
  {
    number: "2",
    title: "Registra tu teléfono",
    desc: "Conecta tu número de WhatsApp Business en segundos. No es nada complicado.",
    color: "from-pink-500 to-pink-400",
    icon: "📱", 
  },
  {
    number: "3",
    title: "Disfruta tu experiencia",
    desc: "Invita a tus clientes a reservar desde tu número de WhatsApp y comienza a ver cómo Buksy gestiona las reservas en línea.",
    color: "from-orange-500 to-red-400",
    icon: "✅", // ejemplo: completado
  },
];


  return (
    <section id="como-funciona" className="bg-gray-50 py-24">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-extrabold mb-4">Tan simple como 1, 2, 3</h2>
        <p className="text-gray-600 mb-12">
Usar una herramienta de reservas nunca fue tan fácil. Buksy hace el trabajo pesado por ti.
        </p>

        <div className="grid md:grid-cols-3 gap-10 relative">
          {steps.map((s) => (
            <div
              key={s.number}
              className="bg-white p-8 rounded-2xl shadow transition-transform transform hover:scale-105 hover:shadow-lg duration-300 relative"
            >
              {/* Badge del número en esquina superior izquierda */}
              <div
                className={`absolute -top-4 -left-4 w-10 h-10 flex items-center justify-center rounded-full text-white font-bold text-lg transition-transform transform hover:scale-110 bg-gradient-to-r ${s.color} animated-badge`}
              >
                {s.number}
              </div>

              {/* Icono del paso */}
              <div className="mx-auto mt-2 w-14 h-14 flex items-center justify-center rounded-2xl text-2xl text-white shadow-md bg-gradient-to-r">
                <div className={`w-full h-full flex items-center justify-center rounded-2xl ${s.color}`}>
                  {s.icon}
                </div>
              </div>

              <h3 className="mt-4 font-semibold text-lg">{s.title}</h3>
              <p className="text-gray-600 text-sm mt-2">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
